export default __webpack_public_path__ + "static/AmericanaStd-Bold-b1566b304b605a16306acbc8212f9ad8.woff";